import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './ScanAuditLogLayout.resolver';
import ScanAuditLogLayout from './ScanAuditLogLayout';

export default async(resolver, { context: RootStoreContext })(
  ScanAuditLogLayout
);
